import { createUuid } from './createUuid';

const monthText = '2024-03';
const hash = createUuid(monthText);

export const sitemapHash = {
  monthText,
  hash,
};
